import React from 'react';
import { observer } from 'mobx-react';
// eslint-disable-next-line max-len
import BusinessMappingTable from '../BusinessMapping/components/BusinessMappingGroupsTable/BusinessMappingViewpointInfoTable';

const BusinessMapping = (props) => (
  <div className="ps-4 pe-4">
    <BusinessMappingTable {...props} />
  </div>
);


export default observer(BusinessMapping);
